import React from 'react';
import '../css/RegistrationHero.css';

const RegistrationHero = () => {
  return (
    <header className="gfi-reg-hero-banner">
      
      {/* Industrial Dark Tint Mask Layer matching image 13_2 */}
      <div className="gfi-reg-hero-tint-overlay"></div>

      <div className="gfi-reg-hero-viewport-container">
        <div className="gfi-reg-hero-alignment-box">
          
          {/* MULTI-LEVEL HIERARCHY BREADCRUMB */}
          <nav className="gfi-reg-breadcrumb-track">
            <span className="gfi-reg-bc-node">GROWTH ACADEMY</span>
            <span className="gfi-reg-bc-arrow">&gt;</span>
            <span className="gfi-reg-bc-node">ABOUT</span>
            <span className="gfi-reg-bc-arrow">&gt;</span>
            <span className="gfi-reg-bc-active">CERTIFICATES</span>
          </nav>

          {/* MAIN WHITE ALL-CAPS HEADER TITLE */}
          <h1 className="gfi-reg-hero-main-title">
            COMPANY REGISTRATION
          </h1>

        </div>
      </div>

    </header>
  );
};

export default RegistrationHero;